export const description =
  "Le chauffe-eau solaire individuel (CESI) couvre 50 à 70 % de l'ECS annuelle d'un foyer. Aides cumulables MaPrimeRénov’ + Prime CEE + éco-PTZ + TVA 5,5 % 2026.";
